import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import closeIcon from '../assets/images/cross-close.svg';
import plusBlueIcon from '../assets/images/plus_blue.svg';
import trashIcon from '../assets/images/trash.svg';
import trashRedBgIcon from '../assets/images/delete-red-bg.svg';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from 'rsuite';
import dayjs from 'dayjs';
import { seteventdetail } from '../features/CreateEventDetailSlice';
import { clearDuplicateTimeSlots, setDuplicateTimeSlots } from '../features/DuplicateTimeSlotSlice';
import { variables, validEmail } from '../Variables';

export const DuplicateSlotSpecificeDate = ({ handleClose, callBackClickHandlerNext, backButtonClickHandler }) => {

    const [duplicateSlots, setDuplicateSlots] = useState([]);
    const [startingOnDate, setStartingOnDate] = useState(null);
    const [endingOnDate, setEndingOnDate] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectSpecificeDate, setSelectSpecificeDate] = useState(null);
    const [currentDayRowdetail, setCurrentDayRowdetail] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [uniqueDateValidation, setUniqueDateValidation] = useState(false);

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const reduxDuplicateTimeSlots = useSelector(state => state.duplicateTimeSlots.duplicateTimeSlots);
    const reduxScheduleTimeSlotsDetail = useSelector(state => state.scheduleTimeSlotsDetail.scheduleTimeSlotsDetail);
    const userAccountType = useSelector(state => state.userAccountType.userAccountType);

    const dispatch = useDispatch();

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
    const generateId = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

    const DuplicateDateObj = {
        id: generateId(),
        day: "",
        durationSlotsRow: [1],
        weekDay: 6,
        specificeDatePickter: null,
        error: "",
        duplicateTimePicker: [{ id: generateId(), startTime: "", endTime: "", isPlusIcon: false, isOkButtonVisible: false, error: ""}],
        isOkButtonVisible: false
    }

    const handleAddNewDateForDuplicateSlot = () => {
        setErrorMessage("");
        setDuplicateSlots([...duplicateSlots, DuplicateDateObj]);
    }

    useEffect(() => {
        if (reduxEventDetail && reduxEventDetail.timeSlots) {
            setTimeSlots(structuredClone(reduxEventDetail.timeSlots));
        }
    }, [reduxEventDetail]);

    const addNewSlotDurationRow = (index) => {

        // new time slot add into correct or select obj
        let rowData;
        if (currentDayRowdetail != null) {
            rowData = currentDayRowdetail[0]
        } else {
            const allDuplicateSlots = duplicateSlots[index];
            const filterCurrentDayClickTimeSlot = timeSlots.filter((item) => item.day == allDuplicateSlots.day);
            rowData = filterCurrentDayClickTimeSlot[0];
        }

        // slot duration value
        let slotDuration = +reduxEventDetail.event.EventDuration;

        // find date time duplciate parent object
        const findSelectTimeSlot = duplicateSlots[index].duplicateTimePicker;
        const lastItemDuplicateTimePickter = findSelectTimeSlot[findSelectTimeSlot.length - 1];
        const lastTimeSlotEndDate = lastItemDuplicateTimePickter.endTime; // get last index object time slot

        const endTimeToSet = new Date(lastTimeSlotEndDate);
        endTimeToSet.setTime(endTimeToSet.getTime() + slotDuration * 60000); // using last end time

        const subTimePickterObj = { id: generateId(), startTime: lastTimeSlotEndDate, endTime: endTimeToSet, isPlusIcon: false, isOkButtonVisible: false, error: "" };
        const updatedSlots = [...duplicateSlots];
        updatedSlots[index].duplicateTimePicker.push(subTimePickterObj);
        setDuplicateSlots(updatedSlots);

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day && item.endTimes.length > 0) {

                //get last element of start time and end time of current duration row
                let lastElementEndTimes = item.endTimes[item.endTimes.length - 1];
                let length = item.endTimes.length;

                //convert duration to milliseconds
                let minutesToAdd = slotDuration * 60000;

                //get last row start and end time of current duration row
                item.startTimes.push({ field: item.day + 'From' + length + 1, date: lastElementEndTimes.date });

                //add minutes
                let endDateToSet = new Date(lastElementEndTimes.date);
                endDateToSet.setTime(endDateToSet.getTime() + minutesToAdd);

                //push final element to start and end times arrays of selected duration row
                item.endTimes.push({ field: item.day + 'To' + length + 1, date: endDateToSet });
                item.durationSlotsRows.push(item.durationSlotsRows.length + 1);

                /*const subTimePickterObj = { id: generateId(), startTime: lastElementEndTimes.date, endTime: endDateToSet };
                const updatedSlots = [...duplicateSlots];
                updatedSlots[index].duplicateTimePicker.push(subTimePickterObj);
                *//*console.log(updatedSlots);*//*
                setDuplicateSlots(updatedSlots);*/
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    // Delete time slots method
    const deleteSlotRow = (parentId, childId, identifiction, parentIndex, day) => {

        if (identifiction == "parent") {

            // remove specifice date obj from ui
            const removeParent = duplicateSlots.filter((item) => item.id != parentId);
            setDuplicateSlots(removeParent);

            // remove and update timeSlot obj "obj adnan sir"
            let updatedTimeSlots = timeSlots.map(item => {
                if (day == item.day) {
                    item.startTimes = [];
                    item.endTimes = [];
                    item.durationSlotsRows = [1];
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);

        } else if (identifiction == "child") {

            // find the index of row
            const indexOfRow = duplicateSlots[parentIndex].duplicateTimePicker.findIndex(slotId => slotId.id == childId);

            // remove the slot time  "obj adnan sir"
            let updatedTimeSlots = timeSlots.map(item => {
                if (day == item.day) {
                    item.startTimes.splice(indexOfRow, 1);
                    item.endTimes.splice(indexOfRow, 1);
                    item.durationSlotsRows.splice(indexOfRow, 1);
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);

            // remove object from ui json 
            const removeSubTimeSlotAndUpdate = duplicateSlots.map(slot => {
                if (slot.id == parentId) {

                    const updatedDurationSlotsRow = [...slot.durationSlotsRow];
                    updatedDurationSlotsRow.splice(indexOfRow, 1);

                    return {
                        ...slot,
                        durationSlotsRow: updatedDurationSlotsRow,
                        duplicateTimePicker: slot.duplicateTimePicker.filter((item) => item.id != childId)
                    }
                }
                return slot;
            })
            setDuplicateSlots(removeSubTimeSlotAndUpdate);
        }
        return;
    }

    const setStartTime = (val, parentIndex, timePickterIndex) => {

        let time = dayjs(val).format("HH:mm");
        let slotDuration = +reduxEventDetail.event.EventDuration;

        // parent object plus icon status
        const findDuplicateTimeSlot = duplicateSlots[parentIndex].duplicateTimePicker[0].isPlusIcon;

        // sub time slot object plus icon status
        const findParentDuplicateTimeSlotArr = duplicateSlots[parentIndex]
        const findDuplicateTimeSlotArr = duplicateSlots[parentIndex].duplicateTimePicker;
        const lastIndexTimePickerSlot = findDuplicateTimeSlotArr[timePickterIndex];
        const isPlusCheck = lastIndexTimePickerSlot.isPlusIcon;

        if (findDuplicateTimeSlot == false && isPlusCheck) {
            let [hours, minutes] = time.split(":").map(Number);

            let startDateSubTimePickter = new Date(lastIndexTimePickerSlot.startTime);
            startDateSubTimePickter.setHours(hours, minutes, 0, 0);

            let endDate = new Date(startDateSubTimePickter);
            endDate.setMinutes(endDate.getMinutes() + slotDuration);

            let updateSubTimeSlot = duplicateSlots.map((item) => {
                if (item.id == findParentDuplicateTimeSlotArr.id) {
                    return {
                        ...item,
                        duplicateTimePicker: item.duplicateTimePicker.map((slot, i) => {
                            if (i == findDuplicateTimeSlotArr.length - 1) {
                                return { ...slot, startTime: new Date(startDateSubTimePickter), endTime: new Date(endDate) };
                            }
                            return slot;
                        })
                    };
                }
                return item;
            });

            //console.log(updateSubTimeSlot);
            setDuplicateSlots(updateSubTimeSlot);
            return;
        }

        let day;
        let Id;
        setErrorMessage("");

        if (selectSpecificeDate != undefined && selectSpecificeDate != null) {
            day = dayjs(selectSpecificeDate).day();
        } else {
            let currentDateSelectDay = duplicateSlots[parentIndex].day
            day = days.indexOf(currentDateSelectDay);
        }

        // get select day
        const selectDay = days[day];

        const filterTimeSlotOnDay = timeSlots.filter(item => item.day == selectDay);
        /* console.log(filterTimeSlotOnDay);*/

        let rowData = filterTimeSlotOnDay[0] //hoursItem; //JSON.parse(e.target.getAttribute("durationitem"));
        let elementId = day + "To" + rowData.durationSlotsRows.length;

        let splittedTime = time.split(":");
        let timeArray = splittedTime.map(item => { return +item });

        let date = new Date();
        let currentDay = date.getDay();

        let distance = (rowData.weekDay || days.length) - currentDay;
        if (distance < 0) {
            date.setDate(date.getDate() + distance + 7);
        }
        else {
            date.setDate(date.getDate() + distance);
        }
        date.setHours(timeArray[0]);
        date.setMinutes(timeArray[1]);

        let startDateTime = new Date(date);
        startDateTime.setMinutes(startDateTime.getMinutes() + slotDuration);

        if (startDateTime.getDate() > date.getDate()) {
            document.querySelector("#" + rowData.day + "From" + rowData.durationSlotsRows.length).parentNode.style.borderColor = "red";
            let message = reduxLanguageTranslations ? (reduxLanguageTranslations["invalidStartTimeErrorMessage"] + ": " + slotDuration) : ("Invalid Start Time! because end time will cross midnight time as slot duration is: " + slotDuration);
            //setTimeSlotValidationMessage(message);
        }

        let updatedTimeSlots = timeSlots.map(item => {
            if (selectDay == item.day) {

                let indexExist = -1;
                item.startTimes.forEach((item, i) => {
                    if (item.field == Id) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: Id, date: date }
                if (indexExist == -1) {
                    item.startTimes.push(timeObj);
                }
                else {
                    item.startTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
        setEndTime(elementId, date, rowData, parentIndex, timePickterIndex);
    }

    const setEndTime = (elementId, date, rowData, parentIndex, timePickterIndex) => {

        let endDate = new Date(date);
        let minutesToAdd = +reduxEventDetail.event.EventDuration
        endDate.setMinutes(endDate.getMinutes() + minutesToAdd);
        let hours = endDate.getHours() < 10 ? "0" + endDate.getHours() : endDate.getHours();
        let minutes = endDate.getMinutes() < 10 ? "0" + endDate.getMinutes() : endDate.getMinutes();
        var time = hours + ":" + minutes;

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {

                let indexExist = -1;
                item.endTimes.forEach((eTime, i) => {
                    if (eTime.field == elementId) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: elementId, date: endDate }
                if (indexExist == -1) {
                    item.endTimes.push(timeObj);
                }
                else {
                    item.endTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);

        // update the object values startTime and endTime
        const filterTimeSlotWithDay = updatedTimeSlots.filter(item => item.day == rowData.day);
        duplicateSlots[parentIndex].duplicateTimePicker[timePickterIndex].startTime = filterTimeSlotWithDay[0].startTimes[0].date;
        duplicateSlots[parentIndex].duplicateTimePicker[timePickterIndex].endTime = filterTimeSlotWithDay[0].endTimes[0].date;
        duplicateSlots[parentIndex].day = filterTimeSlotWithDay[0].day;
        //console.log(filterTimeSlotWithDay);
        setCurrentDayRowdetail(filterTimeSlotWithDay);
    }

    const onChangeHandlerEndTime = (val, selectedTimeSlot, parentIndex, childIndex) => {
        let value = dayjs(val).format("HH:mm");
        let [hours, minutes] = value.split(":").map(Number);
        setErrorMessage("");

        // parent object plus icon status
        const findDuplicateTimeSlot = duplicateSlots[parentIndex].duplicateTimePicker[0].isPlusIcon;

        // sub time slot object plus icon status
        const findDuplicateTimeSlotArr = duplicateSlots[parentIndex].duplicateTimePicker;
        const lastIndexTimePickerSlot = findDuplicateTimeSlotArr[findDuplicateTimeSlotArr.length - 1];
        //const isPlusCheck = lastIndexTimePickerSlot.isPlusIcon;

        const findSelectCurrentChildObj = findDuplicateTimeSlotArr[childIndex].isPlusIcon;

        // sub time slot picker end time change
        if (findDuplicateTimeSlot == false && findSelectCurrentChildObj) {
            let startDateSubTimePickter = new Date(lastIndexTimePickerSlot.startTime);
            startDateSubTimePickter.setHours(hours, minutes, 0, 0);

            let updateSubTimeSlot = duplicateSlots.map((item) => {
                if (item.id == selectedTimeSlot.id) {
                    return {
                        ...item,
                        duplicateTimePicker: item.duplicateTimePicker.map((slot, i) => {
                            if (i == childIndex) {
                                return { ...slot, endTime: new Date(startDateSubTimePickter), isOkButtonVisible: true };
                            }
                            return slot;
                        })
                    };
                }
                return item;
            });

            //console.log(updateSubTimeSlot);
            setDuplicateSlots(updateSubTimeSlot);

            return;
        }

        // parent object update 
        let startDate = new Date(selectedTimeSlot.duplicateTimePicker[0].startTime);
        startDate.setHours(hours, minutes, 0, 0);

        let updateTimeSlot = duplicateSlots.map((item) => {
            if (item.id === selectedTimeSlot.id) {
                return {
                    ...item,
                    duplicateTimePicker: item.duplicateTimePicker.map((slot, i) => {
                        if (i === 0) {
                            return { ...slot, endTime: new Date(startDate) };
                        }
                        return slot;
                    }),
                    isOkButtonVisible: true
                };
            }
            return item;
        });

        //console.log(updateTimeSlot);
        setDuplicateSlots(updateTimeSlot);
    }

    const generateSubSlots = (selectedTimeSlotObj, parentIndex, childIndex) => {

        let slotDuration = +reduxEventDetail.event.EventDuration;

        // parent object plus icon status
        const findDuplicateTimeSlot = duplicateSlots[parentIndex].duplicateTimePicker[0].isPlusIcon;

        // sub time slot object find
        const findDuplicateTimeSlotArr = duplicateSlots[parentIndex].duplicateTimePicker;
        const findSelectCurrentChildObj = findDuplicateTimeSlotArr[childIndex];

        // sub time slot generate multiple slots with "OK" btn
        if (findDuplicateTimeSlot == false && findSelectCurrentChildObj.isPlusIcon) {
            let subLastObjStartDate = new Date(findSelectCurrentChildObj.startTime);
            let subLastObjEndDate = new Date(findSelectCurrentChildObj.endTime);

            if (subLastObjStartDate > subLastObjEndDate || subLastObjStartDate == subLastObjEndDate) {
                setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["endDateLessFromStartDateErrorTxt"] : "Please select end date is greater than start date");
                return;
            }

            let subTimeSlots = [];
            let start = new Date(subLastObjStartDate).getTime();   // convert to milliseconds
            let end = new Date(subLastObjEndDate).getTime();
            let step = slotDuration * 60 * 1000;      // duration in ms

            for (let i = start; i < end; i += step) {
                subTimeSlots.push({
                    id: generateId(),
                    startTime: new Date(i), //.toISOString()
                    endTime: new Date(Math.min(i + step, end)), //.toISOString()
                    isPlusIcon: subTimeSlots.length == 0 ? true : false,
                    isOkButtonVisible: false
                });
            }

            const findSelectObj = duplicateSlots[parentIndex].duplicateTimePicker;
            const startIndex = findSelectObj.findIndex((slots, index) => index == childIndex && slots.isPlusIcon == true); // check first isPlusIcon 
            const endIndex = findSelectObj.findIndex((slots, index) => index > startIndex && slots.isPlusIcon === true); //

            let concatParentAndChildTimeSlots;

            if (endIndex === -1) {
               concatParentAndChildTimeSlots = [
                    ...findSelectObj.slice(0, startIndex),
                    ...subTimeSlots,
                ];
            }

            if (endIndex !== -1) {
                concatParentAndChildTimeSlots = [
                    ...findSelectObj.slice(0, startIndex),
                    ...subTimeSlots,
                    ...findSelectObj.slice(endIndex)
                ]
            }

            let updateTimeSlot = duplicateSlots.map((item) => {
                if (item.id === selectedTimeSlotObj.id) {
                    return {
                        ...item,    // item.duplicateTimePicker.slice(0, -1).concat(subTimeSlots)
                        duplicateTimePicker: concatParentAndChildTimeSlots, //item.duplicateTimePicker.slice(0, childIndex).concat(subTimeSlots), // concat current slot with exist slot and remove last index from exist slot arr
                        isOkButtonVisible: false
                    };
                }
                return item;
            });

            //console.log(updateTimeSlot);
            setDuplicateSlots(updateTimeSlot);
            return;
        }

        let startDate = new Date(selectedTimeSlotObj.duplicateTimePicker[0].startTime);
        let endDate = new Date(selectedTimeSlotObj.duplicateTimePicker[0].endTime);

        if (startDate > endDate || startDate == endDate) {
           // console.log("select any more dates");

            let updateTimeSlot = duplicateSlots.map((item) => {
                if (item.id === selectedTimeSlotObj.id) {
                    return {
                        ...item,
                        duplicateTimePicker: item.duplicateTimePicker.map((slot, i) => {
                            if (i == childIndex) {
                                return { ...slot, error: "endDateGreater" };
                            }
                            return slot;
                        }),
                        isOkButtonVisible: true
                    };
                }
                return item;
            });
            setDuplicateSlots(updateTimeSlot);
            setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["endDateLessFromStartDateErrorTxt"] : "Please select end date is greater than start date");
            console.log(updateTimeSlot);
            return;
        }

        let slots = [];
        let start = new Date(startDate).getTime();   // convert to milliseconds
        let end = new Date(endDate).getTime();
        let step = slotDuration * 60 * 1000;      // duration in ms

        // create sub time slots with select date arrange
        for (let i = start; i < end; i += step) {
            slots.push({
                id: generateId(),
                startTime: new Date(i), //.toISOString()
                endTime: new Date(Math.min(i + step, end)), //.toISOString()
                isPlusIcon: false,
                isOkButtonVisible: false
            });
        }

        // find isPlusIcon true with parent index
        const findIsPlusIconTrue = duplicateSlots[parentIndex].duplicateTimePicker.findIndex(slots => slots.isPlusIcon == true);
        const concatParentAndChildTimeSlots = [...slots, ...duplicateSlots[parentIndex].duplicateTimePicker.slice(findIsPlusIconTrue)];
        const updateParentIndexObj = findIsPlusIconTrue == -1 ? concatParentAndChildTimeSlots.slice(0, -1) : concatParentAndChildTimeSlots

        let updateTimeSlot = duplicateSlots.map((item) => {
            if (item.id === selectedTimeSlotObj.id) {
                return {
                    ...item,
                    duplicateTimePicker: updateParentIndexObj,
                    isOkButtonVisible: false
                };
            }
            return item;
        });

        setDuplicateSlots(updateTimeSlot);
    }

    const addNewSubDuplicateSlot = (item, parentIndex) => {
        let slotDuration = +reduxEventDetail.event.EventDuration; // slot duration

        const findDuplicateTimeSlotsObj = duplicateSlots[parentIndex].duplicateTimePicker;
        const lastIndexDuplicateTimeSlot = findDuplicateTimeSlotsObj[findDuplicateTimeSlotsObj.length - 1];
        const startTime = lastIndexDuplicateTimeSlot.endTime;
        const endTime = new Date(startTime); //findDuplicateTimeSlotsObj.endTime;
        endTime.setMinutes(endTime.getMinutes() + slotDuration);

        const subTimePickterObj = { id: generateId(), startTime: startTime, endTime: endTime, isPlusIcon: true, isOkButtonVisible: false };
        const updatedSlots = [...duplicateSlots];
        updatedSlots[parentIndex].duplicateTimePicker.push(subTimePickterObj);
        //console.log(updatedSlots);
        setDuplicateSlots(updatedSlots);
    }

    useEffect(() => {
        let slotArray = [];
        let mondayIndex = 1; // Index of Monday in the days array

        for (let i = 0; i < 7; i++) {
            // Calculate the day index in the original days array, wrapping around using modulo
            let dayIndex = (mondayIndex + i) % 7;
            let currentDay = days[dayIndex]; // Get the day name (Mon, Tue, etc.)

            slotArray.push({
                day: currentDay,
                weekDay: dayIndex, // Weekday index corresponding to the original array
                durationSlotsRows: [1],
                startTimes: [],
                endTimes: [],
                isChecked: true,
                isOkButtonVisible: false
            });
        }

        if (reduxEventDetail && reduxEventDetail.timeSlots == null) {
            setTimeSlots(slotArray);
        }

        if (reduxDuplicateTimeSlots != null) {
            const formatted = reduxDuplicateTimeSlots.map((item) => ({
                ...item,
                specificeDatePickter: dayjs(item.specificeDatePickter), // mui date format 
                duplicateTimePicker: item.duplicateTimePicker.map((slot) => ({
                    ...slot,
                    startTime: new Date(slot.startTime.replace('Z', '')), // treat as local
                    endTime: new Date(slot.endTime.replace('Z', ''))      // treat as local
                })),
            }));
            setDuplicateSlots(formatted);
        } else {
            setDuplicateSlots([DuplicateDateObj]);
        }

    }, [])

    const onChangeSpecificeDatePickter = (newDate, index) => {
        setErrorMessage("");
        setUniqueDateValidation(false);
        setSelectSpecificeDate(newDate);

        const formattedNewDate = new Date(newDate).toISOString().split("T")[0];

        // check duplicate except itself
        const isDuplicate = duplicateSlots.some(
            (item, i) =>
                i !== index &&
                new Date(item.specificeDatePickter).toISOString().split("T")[0] === formattedNewDate
        );

        if (isDuplicate) {
            setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["alreadyDateExistErrorTxt"] : "This date already exists!");
            setUniqueDateValidation(true);
            return;
        }

        const updatedSlots = [...duplicateSlots];
        updatedSlots[index].specificeDatePickter = newDate;
        updatedSlots[index].error = "";
        //console.log(updatedSlots);
        setDuplicateSlots(updatedSlots);
    }

    const handleNextClickBtn = () => {
        if (duplicateSlots.length == 0) {
            setErrorMessage("Please create any slot");
            return;
        }
        const availableHoursArr = [];
        const repeatAvailableHours = [];
        const CreateDuplicateFreeSlot = +reduxScheduleTimeSlotsDetail.duplicateEachSlotDropdown;
        let prevDay = null;
        let increment = 1;
        let checkEventStartDateTime = "";

        // check validation 
        for (let slot of duplicateSlots) {
            if (!slot.specificeDatePickter) {
                slot.error = "empty";
                setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateErrorTimeSlotMustHaveDate"] : "Each time slot must have a date");
                return;
            }

            for (let time of slot.duplicateTimePicker) {
                if (!time.startTime || !time.endTime) {
                    setErrorMessage(reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateErrorTimeSlotMustHaveStartEndDate"] : "Each slot must have a start and end time");
                    return;
                }
            }
        }

        duplicateSlots.forEach((item) => {
            const specificDate = new Date(item.specificeDatePickter);

            item.duplicateTimePicker = item.duplicateTimePicker.map((timeSlot) => { 
                const start = new Date(timeSlot.startTime);
                const end = new Date(timeSlot.endTime);

                // Replace only the date part with specificDate's Y-M-D
                start.setFullYear(specificDate.getFullYear(), specificDate.getMonth(), specificDate.getDate());
                end.setFullYear(specificDate.getFullYear(), specificDate.getMonth(), specificDate.getDate());

                // Adjust to UTC properly
                start.setMinutes(start.getMinutes() - start.getTimezoneOffset());
                end.setMinutes(end.getMinutes() - end.getTimezoneOffset());

                return {
                    ...timeSlot,
                    startTime: start.toISOString(),
                    endTime: end.toISOString()
                };
            });

            // Push updated times to availableHoursArr
            item.duplicateTimePicker.forEach((timeSlot) => {
                availableHoursArr.push({
                    AllDay: false,
                    Day: item.day,
                    StartDateTime: timeSlot.startTime,
                    EndDateTime: timeSlot.endTime
                });
            });
        });

        availableHoursArr.forEach(item => {

            // Reset increment if day changes
            if (item.Day !== prevDay || checkEventStartDateTime != new Date(item.StartDateTime)) increment = 1;

            for (let i = 0; i < CreateDuplicateFreeSlot; i++) {
               //increment++;

                const start = new Date(item.StartDateTime);
                const end = new Date(item.EndDateTime);

                // if user account type "SystemIntegrator" then 1 second increament not add in time
                if (userAccountType != variables.UserAccountTypeIdentity) {
                    start.setSeconds(increment); // increment add
                    end.setSeconds(increment); // increment add
                    increment++;
                }

                repeatAvailableHours.push({
                    ...item,
                    StartDateTime: start.toISOString(),
                    EndDateTime: end.toISOString()
                });

                checkEventStartDateTime = new Date(item.StartDateTime)
                prevDay = item.Day;
            }
        });


        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: repeatAvailableHours, // repeatAvailableHours, //
            selectedDateRange: null,
            timeSlots: timeSlots,
            invitee: null,
            confirmEventSlot: null
        };

        dispatch(seteventdetail(eventDetail));
        dispatch(setDuplicateTimeSlots(duplicateSlots));
        callBackClickHandlerNext();
    }

    const backToMoveScheduleTimeSlotModel = () => {

        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: null,
            selectedDateRange: null,
            timeSlots: null,
            invitee: null,
            confirmEventSlot: null
        };

        dispatch(seteventdetail(eventDetail));
        dispatch(clearDuplicateTimeSlots(null));
        backButtonClickHandler();
    }

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <ul className="form-steps">
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar active"></li>
                    <li className="step-bar"></li>
                </ul>
                <img src={closeIcon} onClick={handleClose} className="cursor-pointer" />
            </div>
            <p className="form-title mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["SpecifcDateRadioBtnTxt"] : "Specific dates"}</p>
            {
                duplicateSlots.map((item, parentIndex) => {
                    return (
                        <div key={parentIndex} className={`mb-4 ${parentIndex == 0 ? "" : "duplciate-hr-line pt-4"}`}>
                            <p className="mb-2 fw-bold">Date {parentIndex > 11 ? parentIndex + 1 : `0${parentIndex + 1}`} <span className="text-danger">*</span></p>
                            <div className="d-flex">
                                <div className="specificeDatePickter-container me-3">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker
                                                value={item.specificeDatePickter}
                                                onChange={(newDate) => onChangeSpecificeDatePickter(newDate, parentIndex)}
                                                format="DD MMMM YYYY"
                                                minDate={dayjs()} // disables all past dates
                                                sx={{ width: 120 }}
                                                slotProps={{
                                                    textField: {
                                                        placeholder: 'dd/mm/yyyy',
                                                        sx: {
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: item.error == "empty" ? "red" : "",
                                                                },
                                                            },
                                                        },
                                                    },
                                                }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </div>
                                <div>
                                    {
                                        item.duplicateTimePicker.map((timeSlotItem, subIndex) => {
                                            return (
                                                <div key={subIndex} className="time-slot-container d-flex justify-content-between mb-3">
                                                    <TimePicker
                                                        format="HH:mm"
                                                        id={`${item.day}From1`}
                                                        className={`me-2`}
                                                        onChange={(e) => setStartTime(e, parentIndex, subIndex)}
                                                        cleanable={false}
                                                        container={document.body}
                                                        value={timeSlotItem.startTime}
                                                        editable={(subIndex == 0 || timeSlotItem.isPlusIcon == true) && item.specificeDatePickter != null}
                                                        open={false}
                                                        disabled={subIndex !== 0 && timeSlotItem.isPlusIcon !== true}
                                                    />
                                                    <TimePicker
                                                        format="HH:mm"
                                                        id={`${item.day}To1`}
                                                        className={`me-2 ${timeSlotItem.error == "endDateGreater" ? "time-picker-br-red" : ""}`}
                                                        cleanable={false}
                                                        container={document.body}
                                                        value={timeSlotItem.endTime}
                                                        onChange={(val) => onChangeHandlerEndTime(val, item, parentIndex, subIndex)}
                                                        open={false}
                                                        editable={(subIndex == 0 || timeSlotItem.isPlusIcon == true) && item.specificeDatePickter != null}
                                                        disabled={subIndex !== 0 && timeSlotItem.isPlusIcon !== true}
                                                    />
                                                    <div className="time-slot-btn d-flex align-items-center">
                                                        {
                                                            subIndex == 0 ?
                                                                <>
                                                                    {
                                                                        item.isOkButtonVisible ?
                                                                            <button className={`site-btn site-btn-padd`} onClick={() => generateSubSlots(item, parentIndex, subIndex)}>Ok</button>
                                                                            :
                                                                            <>
                                                                                <img src={plusBlueIcon} className="me-1 cursor-show" onClick={item.specificeDatePickter != null && timeSlotItem.startTime != "" ? () => addNewSlotDurationRow(parentIndex) : undefined} />
                                                                                <img src={trashRedBgIcon} className="cursor-show" onClick={() => deleteSlotRow(item.id, timeSlotItem.id, "parent", parentIndex, item.day)} />
                                                                            </>
                                                                    }
                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        timeSlotItem.isPlusIcon ?
                                                                            timeSlotItem.isOkButtonVisible ?
                                                                                <button className={`site-btn site-btn-padd`} onClick={() => generateSubSlots(item, parentIndex, subIndex)}>Ok</button>
                                                                                :
                                                                                <img src={plusBlueIcon} className="cursor-show" onClick={item.specificeDatePickter != null && timeSlotItem.startTime != "" ? () => addNewSlotDurationRow(parentIndex) : undefined} />
                                                                            :
                                                                            <img src={trashIcon} className="cursor-show" onClick={() => deleteSlotRow(item.id, timeSlotItem.id, "child", parentIndex, item.day)} />
                                                                    }
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    <span className="specifceDateAddNewDate-container" onClick={item.specificeDatePickter != null && item.duplicateTimePicker[0].startTime != "" ? () => addNewSubDuplicateSlot(item, parentIndex) : undefined}>
                                        <img src={plusBlueIcon} className="me-2" />
                                        <span className="duplicate-SpecificDate-addNewSlotBtnText">{reduxLanguageTranslations ? reduxLanguageTranslations["addNewTimeSlotBtnTxt"] : "Add new time slot"}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <div className="specifceDateAddNewDate-container duplciate-hr-line pt-2" onClick={handleAddNewDateForDuplicateSlot}>
                <img src={plusBlueIcon} className="me-2" />
                <span className="duplicate-SpecificDate-addNewSlotBtnText">{reduxLanguageTranslations ? reduxLanguageTranslations["DuplicateAddNewSlotBtnTxt"] : "Add new date"}</span>
            </div>
            <p className="text-danger my-2">{errorMessage}</p>
            <div className="d-flex mt-4">
                <button type="button" className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={backToMoveScheduleTimeSlotModel}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBackBtn"] : "Back"}</button>
                <button type="button" className="site-btn site-btn-padd w-100" onClick={handleNextClickBtn}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalNextBtn"] : "Next"}</button>
            </div>
        </>
    )
}
